export enum CameraPermissionStatus {
  GRANTED = 'GRANTED',
  DENIED = 'DENIED',
  NOT_DETERMINED = 'NOT_DETERMINED',
  NO_CORDOVA = 'NO_CORDOVA',
  UNKNOWN = 'UNKNOWN',
}
